<tup-unified-login
  appName="SurveyTime"
  appVersion="{{ appVersion }}"
  appTagLine="Innovative Media Tools To Create Cutting-Edge Campaigns"
  (userAction)="onUserAction($event)"
></tup-unified-login>
